import { Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'

interface ExpandableTextProps {
  text: string
  limit?: number
  className?: string
}

const ExpandableText: React.FC<ExpandableTextProps> = ({ text, limit = 100, className }) => {
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false)

  if (!text) return <span>-</span>

  const isLong = text.length > limit
  const displayText = isOpen || !isLong ? text : `${text.slice(0, limit)}...`
  const formatBotText = (text: string) => {
    const lines = text.split('\n')
    const elements = [] as any

    lines.forEach((line, index) => {
      if (line.startsWith('### ')) {
        elements.push(<h2 key={index}>{line.replace('### ', '')}</h2>)
      } else if (line.startsWith('#### ')) {
        elements.push(<h3 key={index}>{line.replace('#### ', '')}</h3>)
      } else if (/^\d+\. \*\*(.*?)\*\*/.test(line) || /^- \*\*(.*?)\*\*/.test(line)) {
        elements.push(
          <li
            key={index}
            dangerouslySetInnerHTML={{
              __html: line
                .replace(/^\d+\. /, '')
                .replace(/^- /, '')
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>'),
            }}
          />,
        )
      } else if (line.trim() === '') {
        elements.push(<br key={index} />)
      } else {
        elements.push(
          <p
            key={index}
            dangerouslySetInnerHTML={{
              __html: line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>'),
            }}
          />,
        )
      }
    })

    return <div style={{ maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>{elements}</div>
  }
  return (
    <div className={`${className}`}>
      {formatBotText(displayText)}
      {isLong && (
        <Typography color={'primary'} onClick={() => setIsOpen(!isOpen)} className={`cursor-pointer ml-1 `}>
          {isOpen ? 'Read less' : 'Read more'}
        </Typography>
      )}
    </div>
  )
}

export default ExpandableText
